import React from 'react';
import PropTypes from 'prop-types';
import { Spacing, Text } from '@reservamos/elements';
import { useTranslation } from 'react-i18next';
import 'styles/components/SelectedSeats';
import NewSeat from 'ui/atoms/NewSeat';
import { getSeatZoneNumberForPassengerSeat } from 'utils/seatPricing';

const SelectedSeats = ({ seats, applySeatZones, seatPriceZones }) => {
  const { t } = useTranslation('passengers');
  const hasName = seats.some((seat) => seat.firstName !== undefined);

  return (
    <Spacing size={hasName ? 'M' : 'S'} vertical={hasName}>
      <>
        {seats.map((seat) => {
          const { number: seatNumber, category, firstName, lastName, isPickedAsAdjacent } = seat;
          const seatType = isPickedAsAdjacent ? 'adjacent' : 'selected';
          const zone =
            applySeatZones && seatType === 'selected'
              ? getSeatZoneNumberForPassengerSeat(seat, seatPriceZones)
              : undefined;

          return (
            <Spacing alignItems="center" justifyContent="space-between" key={seatNumber}>
              {hasName && (
                <div>
                  <Text weight="bold">{`${firstName} ${lastName}`}</Text>
                  <Text size="S">{t(`type.${category}`)}</Text>
                </div>
              )}
              <NewSeat
                number={seatNumber}
                type={seatType}
                category={seatType === 'adjacent' ? 'adjacent' : category}
                isSmall
                useNewDesign
                showIcon={false}
                zone={zone}
              />
            </Spacing>
          );
        })}
      </>
    </Spacing>
  );
};

SelectedSeats.propTypes = {
  seats: PropTypes.array,
  applySeatZones: PropTypes.bool,
  seatPriceZones: PropTypes.arrayOf(PropTypes.object),
};

SelectedSeats.defaultProps = {
  seats: [],
  applySeatZones: false,
  seatPriceZones: [],
};

export default SelectedSeats;
